module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.paletteId
    }
  }, [_c('svg', {
    staticClass: "sketch",
    on: {
      "mousemove": _vm.moveComponent,
      "mouseup": _vm.removeComponent,
      "mousedown": _vm.chooseComponent,
      "mouseover": _vm.displayTool,
      "mouseout": _vm.hideTool
    }
  }, [_c('g'), _vm._v(" "), _c('g', _vm._l((_vm.linkData), function(item) {
    return _c('PointLink', {
      attrs: {
        "data": item
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f5500554!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/palette.vue
// module id = 77
// module chunks = 0